import Modules from "./modules";
import EmpleadoSlice from "./modules/empleados";
import ProveedoresSlice from "./modules/proveedores";

export const components = {
    modulos: Modules,
    empleados: EmpleadoSlice,
    proveedores: ProveedoresSlice,
}